import { api } from "./api";
import { getAuth, saveAuth } from "./auth";
import { getDeviceId, getDeviceLabel } from "./device";

export async function switchRole(targetRole) {
  if (!["kassa", "voorbereider"].includes(targetRole)) {
    throw new Error("Doelrol moet kassa of voorbereider zijn");
  }
  const auth = getAuth();
  if (!auth) throw new Error("Geen sessie");

  // Admin: alleen frontend swap (admin behoudt admin-token + Team A context)
  if (auth.role === "admin") {
    saveAuth("admin", auth.token, auth.team);
    return auth;
  }
  if (auth.role === targetRole) return auth;

  const { data } = await api.post("/auth/switch-role", {
    target_role: targetRole,
    device_id: getDeviceId(),
    device_label: getDeviceLabel(),
  });
  saveAuth(data.role, data.token, data.team);
  return data;
}
